import { CART_COUNT_LOCAL_STORAGE } from '@/constants'
const defaultState = {
  cart: undefined,
  countQuotations: 0,
  productsInterests: []
}

export const state = () => ({
  ...defaultState
})

// getters
const getters = {
  getCart: (actualState) => actualState.cart,
  getQuotationsAll: (actualState) => actualState.cart?.quotations || [],
  getQuotations: (actualState) =>
    actualState.cart?.quotations?.filter(
      (q) => q.product.sku !== 'COTESPI001' && !q.special_quotation
    ),
  getQuotationsSpecial: (actualState) =>
    actualState.cart?.quotations?.filter(
      (q) => q.product.sku === 'COTESPI001' || q.special_quotation
    ),
  getQuotationsCount: (actualState) =>
    actualState?.cart?.quotations?.length || 0,
  getCountQuotations: (actualState) => actualState.countQuotations,
  getProductsInterests: (actualState) => actualState.productsInterests
}

// mutations
const mutations = {
  clearData(actualState) {
    actualState.cart = defaultState.cart
  },
  setCartData(actualState, cartData = undefined) {
    actualState.cart = cartData
  },
  setCountQuotations(actualState, countQuotations = 0) {
    actualState.countQuotations = countQuotations
    localStorage.setItem(CART_COUNT_LOCAL_STORAGE, countQuotations)
  },
  setProductsInterests(actualState, productsInterests = []) {
    actualState.productsInterests = productsInterests
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
